export const UPLOAD_IMAGE = 'UPLOAD_PRODUCT_IMAGE';
export const UPLOAD_IMAGE_DONE = 'UPLOAD_PRODUCT_IMAGE_DONE';
export const UPLOAD_IMAGE_FAIL = 'UPLOAD_PRODUCT_IMAGE_FAIL';
